import { cn } from '@/utils/cn'
import { type ElementType, type HTMLAttributes, forwardRef } from 'react'

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType
}

export const Card = forwardRef<HTMLElement, CardProps>(({ className, as: Tag = 'div', ...props }, ref) => (
  <Tag ref={ref} className={cn('overflow-hidden rounded-2xl border bg-page', className)} {...props} />
))
Card.displayName = 'Card'
